/** Putopis Alicante — jedan izvor za galeriju (Travelogues + Tours). */
export const ALICANTE_TRAVELOGUE_GALLERY = [
  "/images/alicante/1000127393.jpg",
  "/images/alicante/1000127409.jpg",
  "/images/alicante/1000127996.jpg",
  "/images/alicante/1000128056.jpg",
];
